export default ({request}) => ({
  orderDemandFabricListApi(data = {}) {
    return request({
      url: '/factory/order/demand/fabric/list',
      method: 'post',
      data,
    })
  },
  orderDemandFabricDetailApi(data = {}) {
    return request({
      url: '/factory/order/demand/fabric/detail',
      method: 'post',
      data,
    })
  },
  orderDemandFabricBatchSaveApi(data = {}) {
    return request({
      url: '/factory/order/demand/fabric/batchSave',
      method: 'post',
      data,
    })
  },
  orderDemandFabricSaveApi(data = {}) {
    return request({
      url: '/factory/order/demand/fabric/save',
      method: 'post',
      data,
    })
  },
  orderDemandFabricDelApi(data = {}) {
    return request({
      url: '/factory/order/demand/fabric/del',
      method: 'post',
      data,
    })
  },
  orderGoodsSpecFabricListApi(data = {}) {
    return request({
      url: '/factory/order/goods/spec/fabric/list',
      method: 'post',
      data,
    })
  },
  orderGoodsSpecFabricBatchSaveApi(data = {}) {
    return request({
      url: '/factory/order/goods/spec/fabric/batchSave',
      method: 'post',
      data,
    })
  },
  orderGoodsSpecFabricDelApi(data = {}) {
    return request({
      url: '/factory/order/goods/spec/fabric/del',
      method: 'post',
      data,
    })
  },
})
